/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
type Props = {
  className?: string
  data?: {
    SILVER?: number
    GOLD?: number
    PLATINUM?: number
  }
}
const ChartsWidget14: React.FC<Props> = ({ className, data }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const refreshChart = () => {
    if (!chartRef.current || !data) {
      return
    }
    const height = parseInt(getCSS(chartRef.current, 'height'))
    const categories = ['SILVER', 'GOLD', 'PLATINUM']
    const series = [
      data?.SILVER || 0,
      data?.GOLD || 0,
      data?.PLATINUM || 0
    ]
    const labelColor = getCSSVariableValue('--bs-gray-900')
    const borderColor = getCSSVariableValue('--bs-gray-200')
    const baseColor = getCSSVariableValue('--bs-primary')
    const options: ApexOptions = {
      series: [{
        name: 'Sponsors',
        data: series
      }],
      chart: {
        type: 'bar',
        height: height,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '50%',
          borderRadius: 5
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: categories,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px'
          },
          formatter: function (val: number) {
            return Math.round(val).toString()
          }
        }
      },
      tooltip: {
        y: {
          formatter: function (val: number) {
            return val + ' Sponsors'
          }
        }
      },
      colors: [baseColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4
      }
    }
    const chart = new ApexCharts(chartRef.current, options)
    if (chart) {
      chart.render()
    }
    return chart
  }
  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data])
  return (
    <div className='card' style={{ padding: '0', margin: '0' }}>
      <div className='card-body' style={{ padding: '0', margin: '0' }}>
        <div ref={chartRef} style={{ height: '170px', margin: '0', padding: '0' }}></div>
      </div>
    </div>
  )
}
export { ChartsWidget14 }